// extracted by mini-css-extract-plugin
export default {"root":"Snackbars__root--3r4gh","snackbar":"Snackbars__snackbar--a-agp","snackbar_type_promo":"Snackbars__snackbar_type_promo--Fwdra"};